import React, { useEffect } from 'react';
import "@fancyapps/ui/dist/fancybox/fancybox.css"; // Correct path for FancyBox 4
import { Fancybox } from "@fancyapps/ui";
import '../../styles/media-report/main.css';

const Main = () => {

    // Initialize FancyBox after component mounts
    useEffect(() => {
        Fancybox.bind("[data-fancybox='gallery']", {
            infinite: false,
            loop: true,
        });
    }, []);

    return (

        <div id="mediaReport">
            <div className="media-report-main pb-5">
                <div className="container border rounded">
                    <h3 className="text-left my-heading">Media Report</h3>
                    <main className="main">
                        <div className="container">
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/png/2024/08/kakori.png"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/png/2024/08/kakori.png"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/1.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/1.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/2.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/2.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/3.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/3.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/4.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/4.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/5.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/5.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/6.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/6.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/7.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/7.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/8.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/8.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </div>


    )
}

export default Main;